import { getHeaderContent } from '../../utils/background';

export const UPDATE_HEADER_CONTENT = 'UPDATE_HEADER_CONTENT';
const updateHeaderImageAction = (payload) => ({
    type: UPDATE_HEADER_CONTENT,
    payload,
});

export const updateHeaderImage = () => (dispatch, getState) => {
    const {
        content: { seasonal },
        headerImageIndex,
    } = getState();

    const payload = getHeaderContent({
        seasonalContent: seasonal,
        fixedImageIndex: headerImageIndex,
    });

    dispatch(updateHeaderImageAction(payload));
};
